import { createdDate } from './createdDate';
import { name } from './name';
import { username } from './username';

export const columns = [name, username, createdDate];
